import { render, staticRenderFns } from "./inspectionPointsWithDamages.vue?vue&type=template&id=6a005d1c&"
import script from "./inspectionPointsWithDamages.vue?vue&type=script&lang=js&"
export * from "./inspectionPointsWithDamages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports